<app-customer-page-container theme="light">
  <app-page-header
    *ngIf="!isAssetIcon()"
    [icon]="pageIcon"
    [title]="pageTitle | uppercase"
    theme="light"
    titleColor="primary"
  >
  </app-page-header>
  <app-page-header
    *ngIf="isAssetIcon()"
    [iconSrc]="pageIcon"
    [title]="pageTitle | uppercase"
    theme="light"
    titleColor="primary"
  >
  </app-page-header>

<app-customer-page-content [full]="true">
  <app-global-strategy-info
    *ngIf="investmentStrategyName === availableInvestmentStrategyNames.global"
    [productId]="this.productId"
  ></app-global-strategy-info>
  <app-monetary-strategy-info
    *ngIf="investmentStrategyName === availableInvestmentStrategyNames.monetary"
  ></app-monetary-strategy-info>
  <app-usa-plus-strategy-info
    *ngIf="investmentStrategyName === availableInvestmentStrategyNames.usaPlus"
    [investmentStrategyRouteResolver]="investmentStrategyRouteResolver"
    [productId]="this.productId"
  ></app-usa-plus-strategy-info>
  <app-international-reit-strategy-info
    *ngIf="investmentStrategyName === availableInvestmentStrategyNames.internationalReit"
    [investmentStrategyRouteResolver]="investmentStrategyRouteResolver"
    [productId]="this.productId"
  ></app-international-reit-strategy-info>
  <app-top-value-espana-info
    *ngIf="investmentStrategyName === availableInvestmentStrategyNames.topValueEspana"
    [investmentStrategyRouteResolver]="investmentStrategyRouteResolver"
    [productId]="this.productId"
  ></app-top-value-espana-info>
</app-customer-page-content>
</app-customer-page-container>
